import { colorsPalettes } from "@similarweb/styles";

import { CHART_COLORS } from "app/constants/ChartColors";
import { EDeviceType } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import { EDataType } from "../../../advertisers/overview/components/types";
import { creativeTypeToInfoMap } from "../../ads/hooks/useAdsGallery";
import { SwitcherOption } from "../../shared/ShareTypeSwitcher";

export const switcherOptionToDataType: Record<SwitcherOption, EDataType> = {
    [SwitcherOption.Spend]: EDataType.SPEND,
    [SwitcherOption.Impressions]: EDataType.IMPRESSIONS,
    [SwitcherOption.Visits]: EDataType.VISITS,
};

export const deviceBreakdownConfig = [
    {
        color: CHART_COLORS.mobileDesktopColors[0],
        translationKey: "ad.intelligence.overview.device.breakdown.widget.desktop",
        id: EDeviceType.DESKTOP,
    },
    {
        color: colorsPalettes.carbon[50],
        translationKey: "ad.intelligence.overview.device.breakdown.widget.mobileWeb",
        id: EDeviceType.MOBILE,
    },
];

export const formatBreakdownConfig = [
    {
        color: CHART_COLORS.mobileDesktopColors[0],
        translationKey: creativeTypeToInfoMap.video.name,
        id: "video",
    },
    {
        color: CHART_COLORS.mobileDesktopColors[1],
        translationKey: creativeTypeToInfoMap.banner.name,
        id: "banner",
    },
    {
        color: colorsPalettes.carbon[50],
        translationKey: creativeTypeToInfoMap.native.name,
        id: "native",
    },
];
